import React, {Component} from 'react';
import {Route, Switch} from 'react-router-dom';
import PageHeader from './PageHeader';
import PageFooter from './PageFooter';
import {HomePage} from '../home/';
import {
	ProfilePage,
	ProfileTabs,
	ProfilePageHeader,
	ProfileEditContacts,
	WriteReview,
	ProfileFavouritesPage,
	ProfileMetricsPage,
	AccountPage,
	ProfileEditDetails,
	InviteDialog
} from '../profile/';
import {
	CommunityProfilePage,
	CommunityTabs,
	CommunityProfileHeader,
	CommunityAdminPage,
	CommunityNoticesPage,
	CommunityMembersPage,
	CommunityEditContacts,
	CommunityAddNotice
} from '../community';
import {ActivityStreamPage} from '../stream';
import GettingStarted from '../profile/GettingStarted';
import GettingStartedBio from '../profile/GettingStartedBio';
import GettingStartedCommunity from '../profile/GettingStartedCommunity';
import GettingStartedImages from '../profile/GettingStartedImages';
import GettingStartedBuilding from '../profile/GettingStartedBuilding';
import {SearchPage, SearchCategoryPage, SearchCategoryTabs} from '../search/';
import {ConnectedRouter} from 'connected-react-router';
import NotFoundPage from './NotFoundPage';
import ForbiddenPage from './ForbiddenPage';
import ErrorDialog from './ErrorDialog';
import NewsPress from '../pages/NewsPress';
import Events from '../pages/Events';
import SchoolsPage from '../pages/SchoolsPage';
import RealEstatePage from '../pages/RealEstatePage';
import SportsPage from '../pages/SportsPage';
import FaithPage from '../pages/FaithPage';
import {connect} from 'react-redux';
import uiActions from './ui.actions';
import {LoginDialog, WelcomeDialog, ForgotPassword, ResetPassword} from '../user';
import {enableScroll, disableScroll} from '../scrollPrevention';
import MessagePanel from './MessagePanel';
import NoEmailPage from './NoEmailPage';
import ConfirmDialog from '../widgets/ConfirmDialog';
import ChatPage from '../user/ChatPage';
import VerifyEmail from '../user/VerifyEmail';
import ChangeEmail from '../user/ChangeEmail';
import {ConnectedCommunityEditNotice} from '../community/CommunityAddNotice';
import CommunityPicker from '../search/CommunityPicker';
import LocationPicker from '../search/LocationPicker';
import CategoryPicker from '../search/CategoryPicker';
import {MobileAppPromo} from '../popups';
import Coupons from '../community/coupons/Coupons';
import AddCoupon from '../community/coupons/add-coupon/AddCoupon';
import EditCoupon from '../community/coupons/edit-coupon/EditCoupon';
import RedeemCoupon from '../community/coupons/redeem-coupon/RedeemCoupon';
import CommunityList from '../mobile/community-list/CommunityList';
import ProfileCoupons from '../profile/coupons/ProfileCoupons';
import CouponStatistics from '../community/coupons/coupon-statistics/CouponStatistics';

const {uiModal} = uiActions;

var _hsq = (window._hsq = window._hsq || []);

const MODALS = {
	'profile-edit-details': ProfileEditDetails,
	'profile-edit-contacts': ProfileEditContacts,
	'profile-write-review': WriteReview,
	'community-edit-contacts': CommunityEditContacts,
	'community-add-notice': CommunityAddNotice,
	'community-edit-notice': ConnectedCommunityEditNotice,
	'add-coupon': AddCoupon,
	login: LoginDialog,
	signup: LoginDialog,
	'login-success': LoginDialog,
	welcome: WelcomeDialog,
	error: ErrorDialog,
	'forgot-password': ForgotPassword,
	invite: InviteDialog,
	confirm: ConfirmDialog,
	'change-email': ChangeEmail,
	'community-picker': CommunityPicker,
	'location-picker': LocationPicker,
	'category-picker': CategoryPicker,
	'redeem-coupon': RedeemCoupon,
	'edit-coupon': EditCoupon,
	'mobile-community-list': CommunityList,
	'coupon-statistics': CouponStatistics
};

class Chrome extends Component {
	constructor() {
		super();

		this.state = {
			isIE: false
		};
	}

	componentDidMount() {
		const isIE = !!navigator.userAgent.match(/Trident/g) || !!navigator.userAgent.match(/MSIE/g);
		this.setState({isIE});
		this.sendPageView(this.props.history.location);
		this.props.history.listen(this.sendPageView);
	}

	componentWillReceiveProps(nextProps) {
		if (nextProps.modal && !this.props.modal) {
			disableScroll();
		} else if (!nextProps.modal && this.props.modal) {
			enableScroll();
		}
	}

	sendPageView(location) {
		_hsq.push(['setPath', location.pathname]);
		_hsq.push(['trackPageView']);
	}

	render() {
		const {modal} = this.props;

		const ModalComponent = modal && MODALS[modal];

		return (
			<ConnectedRouter history={this.props.history}>
				<div
					className={`Chrome screenSize-${this.props.screenSize} ${
						this.state.isIE ? 'is-ie' : ''
					} ${modal ? 'modal' : ''}`}>
					<MessagePanel />
					{/* PAGE HEADER routes */}
					<PageHeader
						enlargenFor={[
							'/@:uniqueName',
							'/collections/:uniqueName',
							'/account/:uniqueName',
							'/metrics/:uniqueName',
							'/about/:uniqueName',
							'/admin/:uniqueName',
							'/members/:uniqueName',
							'/coupons/:uniqueName',
							'/profile/coupons/:uniqueName',
							'/!:uniqueName',
							'/stream',
							{
								path: '/news-press',
								title: 'News and press',
								backdrop: '/img/cityscape.jpg',
								showHeading: true
							},
							{
								path: '/events',
								title: 'Upcoming events',
								backdrop: '/img/cityscape.jpg',
								showHeading: true
							},
							{
								path: '/reset-password',
								title: 'Reset password',
								backdrop: '/img/cityscape.jpg',
								showHeading: true
							},
							{
								path: '/verify',
								title: 'Verify email',
								backdrop: '/img/cityscape.jpg',
								showHeading: true
							},
							{
								path: '/getting-started',
								title: 'Welcome!',
								backdrop: '/img/celebration.jpg',
								showHeading: true
							},
							{
								path: '/getting-started-bio',
								title: 'Profile setup',
								backdrop: '/img/celebration.jpg',
								showHeading: true
							},
							{
								path: '/getting-started-community',
								title: 'Profile setup',
								backdrop: '/img/celebration.jpg',
								showHeading: true
							},
							{
								path: '/getting-started-images',
								title: 'Profile setup',
								backdrop: '/img/celebration.jpg',
								showHeading: true
							},
							{
								path: '/getting-started-building',
								title: 'Building profile',
								backdrop: '/img/celebration.jpg',
								showHeading: true
							},
							{
								path: '/faith',
								title: 'B2Me for faith communities',
								backdrop: '/img/faith.jpg',
								showHeading: true
							},
							{
								path: '/schools',
								title: 'B2Me for schools',
								showHeading: false
							},
							{
								path: '/error',
								title: 'Unexpected error',
								backdrop: '/img/cityscape.jpg',
								showHeading: true
							},
							{
								path: '/noemail',
								title: 'No email provided',
								backdrop: '/img/cityscape.jpg',
								showHeading: true
							},
							{
								path: '/forbidden',
								title: 'Forbidden operation',
								backdrop: '/img/cityscape.jpg',
								showHeading: true
							},
							{
								path: '/sign-up',
								title: 'Sign up to B2Me',
								backdrop: '/img/cityscape.jpg',
								showHeading: true
							},
							{
								path: '/404',
								title: 'Page not found',
								backdrop: '/img/cityscape.jpg',
								showHeading: true
							}
						]}>
						<Route
							path="/(@|collections/|account/|metrics/|profile/coupons/):uniqueName"
							component={ProfilePageHeader}
						/>
						<Route
							path="/(!|about/|admin/|members/|coupons/):uniqueName"
							component={CommunityProfileHeader}
						/>
					</PageHeader>

					{/* TAB STRIP routes */}
					<Route
						path="/(@|collections/|account/|metrics/|profile/coupons/):uniqueName"
						component={ProfileTabs}
					/>
					<Route path="/(!|about/|admin/|members/|coupons/):uniqueName" component={CommunityTabs} />
					<Route path="/search-category/" component={SearchCategoryTabs} />

					{/* MAIN PAGE BODY routes */}
					<Switch>
						<Route exact path="/" component={HomePage} />
						<Route path="/search/:query" component={SearchPage} />
						<Route path="/search/" component={SearchPage} />
						<Route path="/search-category/" component={SearchCategoryPage} />
						<Route path="/@:uniqueName" component={ProfilePage} />
						<Route path="/collections/:uniqueName" component={ProfileFavouritesPage} />
						<Route path="/profile/coupons/:uniqueName" component={ProfileCoupons} />
						<Route path="/account/:uniqueName" component={AccountPage} />
						<Route path="/metrics/:uniqueName" component={ProfileMetricsPage} />
						<Route path="/about/:uniqueName" component={CommunityProfilePage} />
						<Route path="/admin/:uniqueName" component={CommunityAdminPage} />
						<Route path="/members/:uniqueName" component={CommunityMembersPage} />
						<Route path="/coupons/:uniqueName" component={Coupons} />
						<Route path="/!:uniqueName" component={CommunityNoticesPage} />
						<Route path="/chats/:uuid?" component={ChatPage} />
						<Route path="/stream/:uuid" component={ActivityStreamPage} />
						<Route path="/stream" component={ActivityStreamPage} />
						<Route path="/reset-password" component={ResetPassword} />
						<Route path="/verify" component={VerifyEmail} />
						<Route path="/getting-started" component={GettingStarted} />
						<Route path="/getting-started-bio" component={GettingStartedBio} />
						<Route path="/getting-started-community" component={GettingStartedCommunity} />
						<Route path="/getting-started-images" component={GettingStartedImages} />
						<Route path="/getting-started-building" component={GettingStartedBuilding} />
						<Route path="/news-press" component={NewsPress} />
						<Route path="/events" component={Events} />
						<Route path="/schools" component={SchoolsPage} />
						<Route path="/real-estate" component={RealEstatePage} />
						<Route path="/sports" component={SportsPage} />
						<Route path="/faith" component={FaithPage} />
						<Route path="/forbidden" component={ForbiddenPage} />
						<Route path="/noemail" component={NoEmailPage} />
						<Route path="/404" component={NotFoundPage} />
						<Route path="*" component={NotFoundPage} />
					</Switch>

					<Switch>
						<Route path="/chats" />
						<Route path="*" component={PageFooter} />
					</Switch>
					{ModalComponent && <ModalComponent />}
					{ModalComponent && <layer className="modal" onClick={this.props.onCancelModal} />}

					{/* SITE POPUPS */}
					<MobileAppPromo />
				</div>
			</ConnectedRouter>
		);
	}
}

const ConnectedChrome = connect(
	state => ({
		modal: state.ui.modal,
		screenSize: state.ui.screenSize
	}),
	dispatch => ({
		onCancelModal: () => dispatch(uiModal(null))
	})
)(Chrome);

export default ConnectedChrome;



// WEBPACK FOOTER //
// ./src/chrome/Chrome.js